export default __webpack_public_path__ + "static/1-70605c37c8e8d8c1fbe1fd23ba986d64.jpg";